<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="8" style="border-right:solid 1px #ccc; padding-right:20px">
        <el-divider content-position="center">溯源项信息</el-divider>
        <el-timeline style="height:45vh">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            type="primary"
            color="#409EFF"
            size="large"
            timestamp
            placement="center"
            style="line-height:22px"
          >
            <el-button
              type="text"
              @click="getMaterialuseinfoListData(activity.id, activity.content)"
              >{{ activity.content }}</el-button
            >
          </el-timeline-item>
        </el-timeline>
      </el-col>
      <el-col :span="16">
        <el-divider content-position="center">用料信息</el-divider>
        <div class="tabel-bar">
          <div class="tabel-bar-left">
            <el-button
              type="primary"
              :size="$store.state.buttonSize"
              @click="materialuserinfoPopup()"
              :disabled="isDisabledAdd"
              >新增填报</el-button
            >
            <RemoveButton
              type="info"
              @click="handleRemoveAll"
              :disabled="!selectionID.length"
              >批量删除</RemoveButton
            >
          </div>
          <div class="tabel-bar-right">
            <el-input
              placeholder="请输入内容"
              :size="$store.state.formSize"
              prefix-icon="el-icon-search"
              v-model="keywords"
              @input="search"
            ></el-input>
            <el-tooltip effect="dark" content="刷新列表" placement="bottom">
              <span
                class="el-icon-refresh icon-hover refresh-btn"
                @click="debounceRefresh"
              ></span>
            </el-tooltip>
          </div>
        </div>
        <p style="padding-bottom: 15px">{{ itemText }}</p>
        <el-table
          v-loading="loading"
          :data="tableData"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column prop="operDate" label="发生日期">
            <template slot-scope="scope">{{
              scope.row.operDate | formatDate
            }}</template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="materialuserinfoPopup(scope.row.id)"
                >编辑</el-button
              >
              <el-button type="text" @click="materialuserinfoDel(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="size"
          :total="total"
        ></pagination>
      </el-col>
    </el-row>
    <!-- 弹出层 -->
    <el-dialog
      :close-on-click-modal="false"
      :append-to-body="true"
      :title="title"
      :visible.sync="materialuseFormVisible"
      center
      width="50%"
    >
      <el-form
        :model="materialuseForm"
        :size="$store.state.formSize"
        :rules="materialuseFormRules"
        ref="refMaterialuseForm"
        label-width="140px"
        style="padding-right: 30px;"
      >
        <el-form-item label="标题：" prop="title">
          <el-input
            v-model="materialuseForm.title"
            placeholder="请输入标题"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="description">
          <el-input v-model="materialuseForm.description" placeholder="请输入描述"></el-input>
        </el-form-item>
        <el-form-item
          v-for="(item, index) in materialuseForm.materialIds"
          :key="item.key"
          :prop="`materialIds.${index}.value`"
          :rules="{ required: true, message: '请选择物料', trigger: 'blur' }"
          label="物料：">
          <el-select
            v-model="item.value"
            style="width:100%;"
            filterable
            :placeholder="materialuseForm.materialName"
          >
            <el-option
              v-for="item in materialList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <i v-if="index === 0" class="product-select-icon el-icon-plus" @click="onAddDynamicForm"></i>
          <i v-else class="product-select-icon  el-icon-close" @click="onDelDynamicForm(index)"></i>
        </el-form-item>
        <el-form-item label="负责人：" prop="manager">
          <el-input
            v-model="materialuseForm.manager"
            placeholder="请输入负责人"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="发生日期：" prop="operDate">
          <el-date-picker
            v-model="materialuseForm.operDate"
            value-format="yyyy-MM-dd"
            autocomplete="off"
            type="date"
            style="width:100%"
            :placeholder="materialuseForm.operDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="生产图片：" prop="img">
          <el-upload
          action="#"
          list-type="picture-card"
          :limit="parseInt('1')"
          :http-request="handleHttpRequest"
          :before-upload="beforeAvatarUpload"
          :on-change="uploadChange"
          :on-remove="uploadRemove"
          :class="{hide:hideUpload}"
          ref="upload"
          :file-list="initFile">
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
              <img
                class="el-upload-list__item-thumbnail" :src="materialuseForm.imgUrl"
              >
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <Dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </Dialog>
        </el-form-item>
      </el-form>
      <div class="text-center">
        <el-button
          type="primary"
          :size="$store.state.buttonSize"
          :disabled="isDisabled"
          @click="debounceSubmit"
          >确 定</el-button
        >
        <el-button :size="$store.state.buttonSize" @click="hanleResetFormVals">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { postWfsImg, wfsImgUrl } from '@/api/common'
import { debounce } from 'throttle-debounce'
import {
  getMaterialuseinfoItemsList,
  getMaterialuseinfoList,
  delMaterialuseinfoList,
  deleteMaterialuseinfoDel,
  putMaterialuseinfoAdd,
  postMaterialuseinfoEdit,
  getMaterialuseinfoDetail
} from '@/api/materialuseinfo'
import { getMaterialmanageList } from '@/api/materialmanage'

const createForm = () => ({
  description: '',
  img: '',
  imgUrl: '',
  itemsId: null,
  manager: null,
  materialId: null,
  materialName: '请选择物料',
  materialIds: [
    { key: '1', value: '' }
  ],
  operDate: '',
  title: ''
})

export default {
  data() {
    return {
      selectionID: [],
      materialList: [],
      materialuseFormVisible: false,
      isDisabled: false,
      isDisabledAdd: true,
      total: 0,
      size: 10,
      page: 1,
      keywords: '',
      initFile: [],
      disabled: false,
      dialogImageUrl: '',
      hideUpload: false,
      dialogVisible: false,
      limitCount: 1,
      itemText: '请先选择左侧节点',
      currentID: null,
      itemsId: null,
      productionRecordId: null,
      loading: true,
      tableData: [],
      imageUrl: '',
      materialuseForm: createForm(),
      materialuseFormRules: {
        operDate: [
          { required: true, message: '请选择发生日期', trigger: 'blur' }
        ],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        description: [
          { required: true, message: '请输入用料描述', trigger: 'blur' }
        ],
        manager: [{ required: true, message: '请输入负责人', trigger: 'blur' }]
      },
      activities: [],
      uid: 1
    }
  },
  props: {
    productId: Number
  },
  computed: {
    title() {
      return this.currentID ? '编辑用料' : '新增用料'
    }
  },
  created() {
    this.debounceRefresh = debounce(300, this.refresh)
    this.debounceSubmit = debounce(300, this.materialuserinfoSubmit)
  },
  methods: {
    handleHttpRequest(option) {
      const formData = new FormData()
      if (option.data) {
        Object.keys(option.data).forEach(key => {
          formData.append(key, option.data[key])
        })
      }
      formData.append(option.filename, option.file)
      postWfsImg(formData).then(res => {
        if (res.status === 1) {
          this.materialuseForm.img = res.data.filePath
          this.materialuseForm.imgUrl = wfsImgUrl(res.data.filePath)
          this.initFile.push({ name: '1', url: wfsImgUrl(res.data.filePath) })
        } else {
          this.$message.error(res.msg || '图片上传失败')
        }
      }).catch(() => {
        this.$message.error('图片上传失败')
      })
    },
    uploadChange(file, fileList) {
      console.log(fileList)
      this.hideUpload = fileList.length >= this.limitCount
    },
    uploadRemove(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    handleRemove(file) {
      this.materialuseForm.img = ''
      this.materialuseForm.imgUrl = ''
      this.initFile = []
      this.$refs.upload.handleRemove(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isType = /^image\/(jpeg|png|jpg|bmp)$/.test(file.type)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isType) {
        this.$message.error('请选择图片文件进行上传!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isType && isLt2M
    },
    onDelDynamicForm(index) {
      this.materialuseForm.materialIds.splice(index, 1)
    },
    onAddDynamicForm() {
      this.materialuseForm.materialIds.push({
        key: ++this.uid,
        value: ''
      })
    },
    hanleResetFormVals() {
      this.$set(this, 'materialuseForm', createForm())
      this.$refs.refMaterialuseForm.clearValidate()
      this.materialuseFormVisible = false
    },
    handleSelectionChange(selection) {
      this.selectionID = selection.map(_ => _.id)
    },
    handleRemoveAll() {
      delMaterialuseinfoList(this.selectionID).then(res => {
        if (res.status === 1) {
          this.$message.success('删除成功')
          this.getMaterialuseinfoListData()
        } else {
          this.$message.error(res.msg)
          return false
        }
      })
    },
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getMaterialuseinfoListData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getMaterialuseinfoListData()
    },
    // 删除用料信息
    materialuserinfoDel(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMaterialuseinfoDel(id).then(res => {
            if (res.status === 1) {
              this.$message.success('删除成功')
              this.getMaterialuseinfoListData()
            } else {
              this.$message.error(res.msg)
              return false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 提交表单
    materialuserinfoSubmit() {
      if (!this.materialuseForm.itemsId && !this.itemsId) this.$message.error('请先选择左侧溯源项')

      this.$refs.refMaterialuseForm.validate(valid => {
        if (!valid) return false
        const materialuserinfoChange = this.currentID
          ? postMaterialuseinfoEdit
          : putMaterialuseinfoAdd
        materialuserinfoChange({
          description: this.materialuseForm.description,
          img: this.materialuseForm.img,
          itemsId: this.materialuseForm.itemsId || this.itemsId,
          manager: this.materialuseForm.manager,
          operDate: this.materialuseForm.operDate,
          materialIds: this.materialuseForm.materialIds.map(_ => _.value),
          title: this.materialuseForm.title,
          id: this.currentID || undefined
        }).then(res => {
          if (res.status === 1) {
            this.currentID
              ? this.$message.success('编辑成功')
              : this.$message.success('新增成功')
            this.getMaterialuseinfoListData()
            this.materialuseFormVisible = false
          } else {
            this.$message.error(res.msg)
            return false
          }
        })
      })
    },
    // 打开表单层
    materialuserinfoPopup(id) {
      this.initFile = []
      this.hideUpload = false
      this.$set(this, 'materialuseForm', createForm())
      const isAdd = !id
      console.log(isAdd)
      this.materialuseFormVisible = true
      if (isAdd) {
        this.currentID = null
      } else {
        this.isDisabled = true
        getMaterialuseinfoDetail(id).then(res => {
          if (res.status === 1) {
            console.log(res)
            this.materialuseForm.description = res.data.description
            this.currentID = id

            this.materialuseForm.operDate = moment(res.data.operDate).format(
              'YYYY-MM-DD'
            )
            if (res.data.imgUrl) {
              this.materialuseForm.imgUrl = res.data.imgUrl
              this.initFile.push({ name: 1, url: res.data.imgUrl })
              this.hideUpload = true
            } else {
              this.hideUpload = false
            }
            this.materialuseForm.img = res.data.img
            this.materialuseForm.title = res.data.title
            this.materialuseForm.itemsId = res.data.itemsId
            this.materialuseForm.manager = res.data.manager
            this.materialuseForm.materialId = res.data.list[0].id
            this.materialuseForm.materialName = res.data.list[0].materialName

            // init masterialIds
            this.materialuseForm.materialIds = []
            res.data.list.forEach((_, i) => {
              this.onAddDynamicForm()
              this.materialuseForm.materialIds[i].value = _.id
            })
            this.isDisabled = false
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 检索
    search() {
      this.getMaterialuseinfoListData()
    },
    // 刷新数据表格
    refresh() {
      this.getMaterialuseinfoListData()
      this.$message.success('数据刷新成功')
    },
    // 获取用料信息列表
    getMaterialuseinfoListData(itemsId, itemsContent) {
      if (itemsContent) { this.itemText = itemsContent }
      this.itemsId = itemsId || this.itemsId
      console.log(this.itemsId)
      if (this.itemsId) this.isDisabledAdd = false
      this.loading = true
      getMaterialuseinfoList({
        page: this.page,
        size: this.size,
        itemsId: this.itemsId
      }).then(res => {
        if (res.status === 1) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    // 获取物料列表
    getMaterialData() {
      getMaterialmanageList({
        page: 1,
        size: 1000
      }).then(res => {
        console.log(res)
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.rows.length; i++) {
            arr.push({
              label: res.data.rows[i].materialName,
              value: res.data.rows[i].id
            })
          }
          this.materialList = arr
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 获取溯源项信息
    getMaterialuseinfoItemsListData() {
      getMaterialuseinfoItemsList(this.productId).then(res => {
        if (res.status === 1) {
          const arr = []
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              id: res.data[i].id,
              content: res.data[i].itemName
            })
          }
          this.activities = arr
          this.getMaterialuseinfoListData(this.activities[0].id, this.activities[0].itemName)
          this.itemsId = this.activities[0].id
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  mounted() {
    this.getMaterialuseinfoItemsListData()
    this.getMaterialData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss" scoped>
.el-timeline {
  overflow-y: auto;
  padding-left: 30px;
  .el-button {
    padding: 0;
  }
}
</style>
<style lang="scss">
.hide .el-upload--picture-card {
    display: none;
}
</style>
